import { gql } from '@apollo/client';

export const STOCK_CAR = gql`
  query StockCarSearch(
    $stockCarIdentifier: StockCarIdentifierInput!
    $groupIds: [String!]
    $imageIds: [String!]
  ) {
    stockCar(stockCarIdentifier: $stockCarIdentifier) {
      code {
        id
      }
      id
      vin
      titleText
      carPrices {
        label
        price {
          value
          valueAsText
          formattedValue
        }
        type
      }
      model {
        name
        salesModelyear
        id {
          code
        }
      }
      colorInfo {
        exteriorColor {
          colorInfo {
            text
          }
          baseColorInfo {
            code
            text
          }
          label
        }
      }
      modelInfo {
        genericModel {
          code
          text
        }
        modelyear
      }
      dealer {
        id
        name
        region
      }
      salesInfo {
        availableFromDateInfo {
          type
          value
        }
        orderStatusText
        saleOrderTypeText
      }
      subtitleText
      cartypeText
      commissionNumber
      images(groupIds: $groupIds, imageIds: $imageIds) {
        url
        type
        mimeType
        id {
          group
          image
        }
      }
      dynamicAttributes {
        id
        value
      }
      manufacturerSpecificItems {
        ... on StockCarManufacturerAudi {
          cdbItems {
            id
            value
          }
        }
      }
    }
  }
`;
